module.exports = __webpack_public_path__ + "website/img/local-2.1be5699a.png";